import "./suggestion.scoped.scss";

export default function SuggestContainer({ children }) {
  return (
    <div className="position-absolute rounded-bottom shadow-lg bg-white overflow-auto suggestion-container w-100 px-2">
      {children}
    </div>
  );
}
